import { required } from 'vee-validate/dist/rules';

export default {
  ...required,
  params: required.params.concat(['condition']),
  validate: async (value, { condition = null }) => {
    return {
      valid: (typeof condition === 'boolean' && condition === true) ? required.validate(value) : true,
      required: true,
    };
  },
};
